import { getNodeText, hasRenderableMedia } from '~kui/components/KUI/Core/Input/RichTextEditor/Renderer/useRichTextEditorRenderer';
import { parseStringToTipTapJson } from '~kui/components/KUI/Core/Input/RichTextEditor/useRichTextEditor';

/** Whether a plain-text field holds any actual text. */
export const hasText = (value: string | null | undefined): boolean => (value ?? '').trim() !== '';

/**
 * Whether a rich-text field has anything the renderer would show: text, or an
 * image or social embed in a spot the renderer draws media. An emptied editor
 * leaves an empty TipTap doc string (not ''), which reads as blank.
 */
export const hasTipTapContent = (body: string): boolean => {
  if (!body) {
    return false;
  }

  const doc = parseStringToTipTapJson(body);

  return getNodeText(doc).trim() !== '' || hasRenderableMedia(doc);
};

/**
 * Plain text of a rich-or-plain string field. Fields sourced from rich editors
 * may hold a TipTap doc string; plain strings pass through unchanged.
 */
export const tipTapToPlainText = (value: string | null | undefined): string => {
  if (!value) {
    return '';
  }

  return getNodeText(parseStringToTipTapJson(value)).trim();
};
